export const CONVERSAYION_MESSAGE_TYPES = {
  AI: 'ai',
  AI_DELTA: 'ai_delta',         // one streamed token of the answer (backend line)
  AI_STREAMING: 'ai_streaming', // bubble collecting those tokens until the final AI line
  HUMAN: 'human',
  AI_THINKING: 'ai_thinking',
  ERROR: 'error',
  UNKNOWN: 'unknown',
  SYSTEM: 'system',
  TOOL_EXECUTION: 'tool_execution',
  FUNCTION_EXECUTION: 'function_execution'
};

export default CONVERSAYION_MESSAGE_TYPES;